export default __webpack_public_path__ + "static/media/right_angle.c47bb9fa.png";